import { createSlice } from '@reduxjs/toolkit';
import { globalApi, regionApi, regionInstanceApi } from '../services';
import { getInstanceDetail } from '../utils';
import { RootState } from './index';
import { MY_ACCOUNT_LIST } from '../utils/helper';
interface InstanceStore {
  system: Record<string, any>;
  instances: Record<string, any>;
  rejectedInstances: Record<string, any>;
}

const initialState: InstanceStore = {
  system: {},
  instances: { [MY_ACCOUNT_LIST]: {} },
  rejectedInstances: { [MY_ACCOUNT_LIST]: {} }
};

const instanceSlice = createSlice({
  name: 'instance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      globalApi.endpoints.getSystemData.matchFulfilled,
      (state, { payload }) => {
        state.system = payload;
      }
    );
    builder.addMatcher(
      regionApi.endpoints.regionLogin.matchFulfilled,
      (state, { payload }) => {
        const region: Record<string, any> = payload || {};
        if (region?.groups) {
          region?.groups.flat(1).forEach((obj: Record<string, any>) => {
            if (obj?.id) {
              state.instances[obj?.id] = state.instances[obj?.id] || {};
            }
          });
        }
      }
    );
    builder.addMatcher(
      regionInstanceApi.endpoints.getInstByAccount.matchFulfilled,
      (state, { payload }) => {
        const account_id = payload?.account_id;
        if (account_id) {
          let instance = payload?.data || {};
          const daysToRemindExpiry = state.system?.days_to_remind_expiry || 30;
          const evaluateQuotaRatio = state.system?.evaluate_quota_ratio || 1;
          const detail: Record<string, any> = getInstanceDetail(
            instance,
            daysToRemindExpiry,
            evaluateQuotaRatio
          );
          const group_id = payload?.group_id || MY_ACCOUNT_LIST;
          const group = state.instances[group_id] || {};
          state.instances[group_id] = {
            ...group,
            [account_id]: {
              ...instance,
              detail,
              vCPU: instance.cpu_usage
                ? String(instance.cpu_usage) + '%'
                : instance.cpu_usage,
              ram: instance.mem_usage
                ? String(instance.mem_usage) + '%'
                : instance.mem_usage,
              diskSize: instance.disk_size | 0,
              disk: detail?.disk,
              diskUsage: parseFloat(detail?.disk?.percent),
              resourceSpeed: parseFloat(detail?.resource?.speed),
              resourceSize: parseFloat(detail?.resource?.size),
              resourceSizeGB: parseFloat(detail?.resource?.size_gb),
              resourceAddon: parseFloat(detail?.resource?.addon),
              resourceAddonGB: parseFloat(detail?.resource?.addon_gb)
            }
          };
          if (state.rejectedInstances[group_id]?.[account_id]) {
            const newGroupObj = { ...state.rejectedInstances[group_id] };
            delete newGroupObj[account_id];
            state.rejectedInstances[group_id] = newGroupObj;
          }
        }
      }
    );

    builder.addMatcher(
      regionInstanceApi.endpoints.getInstByAccount.matchRejected,
      (state, { payload, error, meta }) => {
        console.warn(
          '----------- get_instance_info rejected',
          meta,
          payload,
          error
        );
        const account_id = meta?.arg?.originalArgs?.account?.account_id || '';
        const group_id =
          meta?.arg?.originalArgs?.account?.group_id || MY_ACCOUNT_LIST;
        if (account_id) {
          state.rejectedInstances[group_id] =
            state.rejectedInstances[group_id] || {};
          state.rejectedInstances[group_id][account_id] = {
            ...meta?.arg?.originalArgs,
            error: error,
            payload: payload
          };
        }
      }
    );
  }
});

const { reducer, actions } = instanceSlice;

export const selectInstances = (state: RootState) => state.instance?.instances;
export const selectRejectedInstances = (state: RootState) =>
  state.instance?.rejectedInstances;
export default reducer;
